import { Link, useNavigate } from "react-router-dom";
import BackofficeLayout from "@/components/layouts/BackofficeLayout";
import { Button } from "@/components/ui/button";
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle 
} from "@/components/ui/card";
import { ChevronLeft } from "lucide-react";
import DocumentForm from "@/components/documents/DocumentForm";

const DocumentCreate = () => {
  const navigate = useNavigate();

  const handleSuccess = (documentId: number) => {
    navigate(`/backoffice/documents/${documentId}/edit`);
  };

  return (
    <BackofficeLayout>
      <div className="space-y-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="space-y-1">
            <Button asChild variant="outline" size="sm">
              <Link to="/backoffice/documents">
                <ChevronLeft className="mr-1 h-4 w-4" />
                Back to Documents
              </Link>
            </Button>
            <h1 className="text-3xl font-bold tracking-tight">Create New Document</h1>
            <p className="text-gray-500">
              Add a new document to the system with information, groups, and form content
            </p>
          </div>
        </div>

        <DocumentForm onSuccess={handleSuccess} />
      </div>
    </BackofficeLayout>
  );
};

export default DocumentCreate;
